export default "__VITE_ASSET__f11bc010__"